import Base from './base';

class Group extends Base {
	constructor(el) {
		super(el);

		this.control = this.query('[aria-controls]');

		const contentSelector = `#${this.control.getAttribute('aria-controls')}`;

		this.content = this.query(contentSelector);

		this.on('click');
	}

	get isExpanded() {
		return this.control.hasAttribute('aria-pressed');
	}

	set isExpanded(expanded) {
		if (expanded) {
			this.control.setAttribute('aria-pressed', true);
			this.content.removeAttribute('aria-hidden');
		} else {
			this.control.removeAttribute('aria-pressed');
			this.content.setAttribute('aria-hidden', true);
		}
	}

	onClick(e) {
		const { target } = e;

		if (target === this.control) {
			this.toggle();
		}
	}

	toggle() {
		this.isExpanded = !this.isExpanded;
	}
}

export default Group;
